import { render, staticRenderFns } from "./ModalUploadSeminar.vue?vue&type=template&id=3305b811&"
import script from "./ModalUploadSeminar.vue?vue&type=script&lang=js&"
export * from "./ModalUploadSeminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports